    window.iWishData.country = $('.currency-picker').val().slice(0,-1);
    if($('.currency-picker').val() == 'USD'){
        window.iWishData.money_format =  "${{amount}}";
      }
      else if($(this).val() == 'CAD'){
        window.iWishData.money_format = "${{amount}}";
      }
      else if($(this).val() == 'GBP'){
        window.iWishData.money_format = `£{{amount}}`;
      }
      else if($(this).val() == 'EUR'){
        window.iWishData.money_format = `€{{amount}}`;
      }
      else if($(this).val() == 'JPY'){
        window.iWishData.money_format = `¥{{amount}}`;
      }
    $('body').on('change','.currency-picker',function(){
      window.iWishData.country = $(this).val().slice(0,-1);
      if($(this).val() == 'USD'){
        window.iWishData.money_format =  "${{amount}}";
      }
      else if($(this).val() == 'CAD'){
        window.iWishData.money_format = "${{amount}}";
      }
      else if($(this).val() == 'GBP'){
        window.iWishData.money_format = `£{{amount}}`;
      }
      else if($(this).val() == 'EUR'){
        window.iWishData.money_format = `€{{amount}}`;
      }
      else if($(this).val() == 'JPY'){
        window.iWishData.money_format = `¥{{amount}}`;
      }          
    })
